"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TurnEndedEventArgs = void 0;
const EventType_1 = require("../EventType");
class TurnEndedEventArgs {
    constructor() {
        this.__type = EventType_1.EventType.TurnEnded;
        this.__typeName = "TurnEnded";
    }
}
exports.TurnEndedEventArgs = TurnEndedEventArgs;
